import React from "react";

const Divider = ({ style }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "1px",
        backgroundColor: "rgba(255,255,255,0.5)",

        ...style, // Если передать дополнительные стили
      }}
    ></div>
  );
};

export default Divider;
